import { isShowing, revealedRounds, roundRevealAt, showRoundIndex } from './battleModel';
import { DROP_FLIGHT_MS } from './showTiming';

export interface CardRoundLike {
  id: string;
  bigDrops: number;
  droppedValue: number;
  topDrop?: { slot: number; hashName: string; price: number; imageUrl?: string | null; rarityColor?: string | null } | null;
}

export interface CardBattleLike {
  status: string;
  completedAt?: string | null;
  rounds: CardRoundLike[];
  participants: unknown[];
}

export interface CardShowState {
  running: boolean;
  currentRound: number | null;
  revealed: boolean;
  flight: NonNullable<CardRoundLike['topDrop']> | null;
  flightRoundId: string | null;
  flightColor: string;
  flightElapsed: number;
  flying: boolean;
  bank: number;
}

const FALLBACK_DROP_COLOR = '#ffd700';

export const cardShowState = (battle: CardBattleLike, now: number, lobby: boolean): CardShowState => {
  const running = lobby && isShowing(battle, now);
  const currentRound = running && battle.status === 'COMPLETED' ? showRoundIndex(battle, now) : null;
  const revealAt = currentRound !== null ? roundRevealAt(battle, currentRound) : null;
  const revealed = revealAt !== null && revealAt <= now;
  const round = revealed && currentRound !== null ? battle.rounds[currentRound] : undefined;
  const flight = round && round.bigDrops > 0 ? (round.topDrop ?? null) : null;
  const flightElapsed = revealAt !== null ? now - revealAt : 0;
  const bankRounds = running ? revealedRounds(battle, now) : battle.status === 'COMPLETED' ? battle.rounds.length : 0;
  return {
    running,
    currentRound,
    revealed,
    flight,
    flightRoundId: flight && round ? round.id : null,
    flightColor: flight?.rarityColor ?? FALLBACK_DROP_COLOR,
    flightElapsed,
    flying: flight !== null && flightElapsed < DROP_FLIGHT_MS,
    bank: battle.rounds.slice(0, bankRounds).reduce((sum, r) => sum + r.droppedValue, 0),
  };
};
